import {getMobileView} from "../components/helpers";

const activePanel = (state = getMobileView()?'Player':"10", action)=>{
    if (action.type === "SET_ACTIVE_PANEL") {
        state = action.key
    }
    return state;
}

export default activePanel;